import React, { useState } from "react";
import { Grid, Typography, Box, Slider } from "@mui/material";
import { Link } from "react-router-dom";
const discoverbrand = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/brand.png";
const border = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/border.png";
const samsung = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/samsung.png";
const booking = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/booking.png";
const boat = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/boat.png";
const Nyka = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/amazon (1).png";
const Clove = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/clovee.png";
const trumeds = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/trumeds.png";
const adidas = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/adidas.png";
const xyxx = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/xyxx.png";
const Strch = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/strchh.png";
// import dreamco from "../../images/diwali/dreamco.png";
const SSbeauty = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/amazon.png";
const mcaffine = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/mcaffine.png";
const ssbeauty = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/ssbeauty.png";
const forest = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/forest.png";
const getmorepointimg = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/getmorepointimg.png";
const kamaayurveda = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/kamaayurveda.png";

const thumbimg = "https://d2sriifpjiqv0p.cloudfront.net/savings-league/thumbimg.png";


export default function DiscoverBrand() {
  const [isLoggedIn, setIsLoggedIn] = useState(true);
  const [activeLink, setActiveLink] = useState(null);
  const segment = localStorage.getItem('segment')
  const brandsValue = Number(localStorage.getItem('savings_brand_discovery') || 0);
  const discovery = Number(localStorage.getItem('savings_brand_discovery') || 0);
 
  function getMinusOneDayDisplay() {
    const raw = localStorage.getItem('updated_at'); // e.g. "18/09/2025" or "2025-09-18T12:34:56Z"
    let d;
  
    if (raw && /^\d{2}\/\d{2}\/\d{4}$/.test(raw)) {
      // parse DD/MM/YYYY
      const [dd, mm, yyyy] = raw.split('/').map(Number);
      d = new Date(yyyy, mm - 1, dd);
    } else if (raw) {
      // try Date parsing for ISO-like strings
      const parsed = new Date(raw);
      d = isNaN(parsed) ? new Date() : parsed;
    } else {
      d = new Date(); // fallback: today
    }
  
    d.setDate(d.getDate() - 1); // subtract one day
  
    // Format as DD/MM/YYYY
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const yyyy = d.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  }
  
  
  
  
  
  
  const handleLinkClick = (link) => {
    setActiveLink(link);
  };

  const data = [
    {
      imgSrc: "https://d2sriifpjiqv0p.cloudfront.net/diwali/brand/Reliance Digital.png",
      title: "Reliance Digital",
      link: segment == 1 || segment == 2 || segment == 4
        ? "cashkaro://stores/reliancedigital-coupons-lead2025"
        : "cashkaro://stores/reliancedigital-coupons-lead2025",
    },
    {
      imgSrc: "https://d2sriifpjiqv0p.cloudfront.net/diwali/brand/The Derma Co..png",
      title: "The Derma Co.",
      link: segment == 1 || segment == 2 || segment == 4
        ? "cashkaro://stores/thedermaco-coupons-lead2025"
        : "cashkaro://stores/thedermaco-coupons-lead2025",
    },
    {
      imgSrc: "https://d2sriifpjiqv0p.cloudfront.net/diwali/brand/The Man Company.png",
      title: "The Man Company",
      link: segment == 1 || segment == 2 || segment == 4
        ? "cashkaro://stores/themancompany-coupons-lead2025"
        : "cashkaro://stores/themancompany-coupons-lead2025",
    },
    {
      imgSrc: "https://d2sriifpjiqv0p.cloudfront.net/diwali/brand/minimalist.png",
      title: "Minimalist",
      link: segment == 1 || segment == 2 || segment == 4
        ? "cashkaro://stores/minimalist-coupons-lead2025"
        : "cashkaro://stores/minimalist-coupons-lead2025",
    },
    {
      imgSrc: "https://d2sriifpjiqv0p.cloudfront.net/diwali/brand/Cleevo.png",
      title: "Cleevo",
      link: segment == 1 || segment == 2 || segment == 4
        ? "cashkaro://stores/cleevo-offers-lead2025"
        : "cashkaro://stores/cleevo-offers-lead2025",
    },
    {
      imgSrc: "https://d2sriifpjiqv0p.cloudfront.net/diwali/brand/Adidas.png",
      title: "Adidas",
      link: segment == 1 || segment == 2 || segment == 4
        ? "cashkaro://stores/adidas-lead2025"
        : "cashkaro://stores/adidas-lead2025",
    },
    {
      imgSrc: "https://d2sriifpjiqv0p.cloudfront.net/diwali/brand/Levis.png",
      title: "Levis",
      link: segment == 1 || segment == 2 || segment == 4
        ? "cashkaro://stores/levis-offers-lead2025"
        : "cashkaro://stores/levis-offers-lead2025",
    },
    {
      imgSrc: "https://d2sriifpjiqv0p.cloudfront.net/diwali/brand/Mokobara.png",
      title: "Mokobara",
      link: segment == 1 || segment == 2 || segment == 4
        ? "cashkaro://stores/mokobara-coupon-codes-lead2025"
        : "cashkaro://stores/mokobara-coupon-codes-lead2025",
    },
    {
      imgSrc: "https://d2sriifpjiqv0p.cloudfront.net/diwali/brand/Trumeds.png",
      title: "Trumeds",
      link: segment == 1 || segment == 2 || segment == 4
        ? "cashkaro://stores/truemeds-coupon-code-lead2025"
        : "cashkaro://stores/truemeds-coupon-code-lead2025",
    },
    {
      imgSrc: "https://d2sriifpjiqv0p.cloudfront.net/diwali/brand/Puer.png",
      title: "Puer",
      link: segment == 1 || segment == 2 || segment == 4
        ? "cashkaro://stores/puer-coupon-codes-lead2025"
        : "cashkaro://stores/puer-coupon-codes-lead2025",
    },
  ];
  return (
    <Grid container sx={{ background: "#fff" }}>
      <Grid item xs={12} sm={12} md={4} lg={4}></Grid>
      <Grid item xs={12} sm={12} md={4} lg={4}>
        <Grid
          sx={{
            background: '#1F162E',

            width: "100%",
          }}
        >
          <Grid pb={2}>
            <img src="https://d2sriifpjiqv0p.cloudfront.net/diwali/brand.png" style={{ width: "100%", }} />
          </Grid>
          <Grid>
            <Box px={3} pb={3}>
              <Typography sx={{ textAlign: 'center', fontWeight: '500', fontSize: '0.875rem', color: '#fff' }}>Your brand discovery progress</Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                padding: "0 24px 8px",
              }}
            >
              <Typography
  sx={{
    color:
      Number(localStorage.getItem("savings_brand_discovery") || 0) >= 5
        ? "#FE8B37"
        : "#fff",
    textAlign: "center",
    fontFamily: "Metropolis",
    fontSize: "10px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "10px",
    width: "33.3%",
  }}
>
  + 30 points
</Typography>

              <Typography
                sx={{
                  color:
      Number(localStorage.getItem("savings_brand_discovery") || 0) >= 10
        ? "#FE8B37"
        : "#fff",
                  textAlign: "right",
                  fontFamily: "Metropolis",
                  fontSize: "10px",
                  fontStyle: "normal",
                  fontWeight: 600,
                  lineHeight: "10px",
                  width: "33.3%",
                }}
              >
                + 60 points
              </Typography>
            </Box>
            <Box sx={{
              padding: "0 32px",
              position: "relative"
            }}

            >

              <Slider
                aria-label="Temperature"
                disabled
                // getAriaValueText={valuetext}
                valueLabelDisplay="off"
                defaultValue={localStorage.getItem('savings_brand_discovery') || 0}
                shiftStep={30}
                // orientation="vertical"
                step={5}
                marks
                min={0}
                max={10}
                sx={{
                  color: "#E85F34", // Change the color here
                  padding: "4px !important",
                  boxShadow: "0px 0px 0px",
                  borderRadius: "20px",
                  marginBottom: "6px",
                  zIndex: "222",
                  position: "relative",
                  height: 8, // Change the height here
                  '&.Mui-disabled': {
                    color: '#E85F34', // Custom color for disabled state
                  },
                  "& .MuiSlider-thumb": {
                    height: 26,
                    boxShadow: "0px 0px 0px",
                    width: 37,
                    boxShadow: "inherit !important",
                    background: `url(${thumbimg})`, // Change thumb color
                    border: "0px solid currentColor", // Add border if needed
                    "&:focus, &:hover, &.Mui-active": {
                      boxShadow: "inherit",
                    },
                    ":before": {
                      boxShadow: "0px 0px 0px",
                    },
                    "&::after": {
                      content: discovery >= 10 ? `"${discovery}"` : `"${discovery}Brands"`,

                      position: "absolute",
                      top: "6px",
                      color: "#FFF",
                      left: discovery <= 10 ? "0%" : "70%",
                      fontSize: "10px",
                      fontWeight: "bold",
                      transform: "none",
                    },
                  },
                  "& .MuiSlider-track": {
                    height: 14, // Change track height
                  },
                  "& .MuiSlider-rail": {
                    height: 14, // Change rail height
                    backgroundColor: "#36276A", // Rail color
                    opacity: "1",
                  },
                  "& .MuiSlider-mark": {
                    backgroundColor: "#36276A", // Mark color
                    height: 20, // Mark height
                    width: 2, // Mark width
                    borderRadius: "20px",
                    "&.MuiSlider-markActive": {
                      backgroundColor: "#E85F34", // Active mark color
                    },
                  },
                }}
              />
              {/* <Box sx={{
              width: "60.314px",
              height: "8px",
              flexShrink: 0,
              borderRadius: "36.188px",
              background: "#371D0C",
              filter: "blur(2.507853388786316px)",
              margin:"0 auto",
              left:"0",
              right:"0",
              bottom:"11px",
              position:"absolute",
              zIndex:"1"
            }}>

            </Box> */}
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                padding: "0 24px 32px",
              }}
            >
              <Typography
                sx={{
                  color: "#FFF",
                  textAlign: "center",
                  fontFamily: "Metropolis",
                  fontSize: "8px",
                  fontStyle: "normal",
                  fontWeight: 400,
                  lineHeight: "10px",
                }}
              >
                0 Brands
              </Typography>
              <Typography
                sx={{
                  color: "#FFF",
                  textAlign: "center",
                  fontFamily: "Metropolis",
                  fontSize: "8px",
                  fontStyle: "normal",
                  fontWeight: 400,
                  lineHeight: "10px",
                }}
              >
                5 Brands
              </Typography>
              <Typography
                sx={{
                  color: "#FFF",
                  textAlign: "center",
                  fontFamily: "Metropolis",
                  fontSize: "8px",
                  fontStyle: "normal",
                  fontWeight: 400,
                  lineHeight: "10px",
                }}
              >
                10 Brands
              </Typography>
            </Box>
            <Box>
              <Typography
                sx={{
                  color: "rgba(255, 255, 255, 0.50)",
                  textAlign: "center",
                  fontFamily: "Metropolis",
                  fontSize: "10px",
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "140%",
                  paddingBottom: "20px",
                }}
              >
<span>*Last updated on {getMinusOneDayDisplay()}</span>

              </Typography>
            </Box>
          </Grid>
          <Grid
            container
            spacing={0}
            sx={{ justifyContent: "center" }}
            pb={5}
            pl={2}
            pr={2}
          >
            {data.map((item, index) => (
              <Grid item xs={4} key={index}>
                <a
                  href={item.link}
                  style={{ textDecoration: "none" }}
                  target="_blank"
                  onClick={() => handleLinkClick(item.link)}
                >
                  <img src={item.imgSrc} style={{ width: "100%" }} />
                  <Typography
                    sx={{
                      color: "#FFF",
                      textAlign: "center",
                      fontFamily: "Metropolis",
                      fontSize: "12px",
                      fontStyle: "normal",
                      fontWeight: 600,
                      lineHeight: "120%",
                      position: "relative",
                      top: "-10px",
                      textDecoration: "none",
                    }}
                  >
                    {item.title}
                  </Typography>
                </a>
              </Grid>
            ))}
          </Grid>

        </Grid>
      </Grid>
      <Grid item xs={12} sm={12} md={4} lg={4}></Grid>{" "}
    </Grid>
  );
}
